import React from 'react'
import { Link } from 'react-router-dom'

import Navbar from '../../components/navbar'
import AboutThree from '../../components/about-three'
import ClientTwo from '../../components/client-two'
import BlogOne from '../../components/blog-one'
import About from '../../components/about'
import TeamOne from '../../components/team-one'
import Footer from '../../components/footer'

import bg1 from '../../assets/images/corporate/bg.jpg'
import bg2 from '../../assets/images/corporate/bg.jpg'
///Users/siva/Documents/B2B/b2blogobasic.png
import cta from '../../assets/images/cta.jpg'

import { feature } from '../../data'

export default function IndexCorporate() {
  return (
    <>
     <Navbar navLight={true}/> 

    <section className="bg-half-260 d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'top center'}}>
      <div className="bg-overlay opacity-9"></div>
      <div className="container">
          <div className="row align-items-center mt-5">
              <div className="col-lg-6 col-md-7">
                  <div className="title-heading position-relative mt-4" style={{zIndex: '1'}}>
                      <h1 className="heading text-white title-dark fw-bold mb-3">Unlock your business <br/> potential with us.</h1>
                      <p className="para-desc text-white-50">Start work with <span className="text-primary">Leaping</span>. Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                      <div className="mt-4 pt-2">
                          <Link to="#" className="btn btn-primary mb-2 me-2">Get Started</Link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section"> 
      <AboutThree/>

      <div className="container mt-100 mt-60">
          <div className="row justify-content-center">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Our Services</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>

          <div className="row">
            {feature.map((item,index)=>{
              let Icon = item.icon
              return(
                  <div className="col-lg-3 col-md-4 col-12 mt-4 pt-2" key={index}>
                      <div className="feature p-3 py-5 rounded text-center">
                          <i className="h1 text-primary"><Icon/></i>
                          <div className="content">
                              <h4 className="title mt-3">{item.title}</h4>
                              <p className="text-muted mt-2 mb-0">{item.desc}</p>
                          </div>
                      </div>
                  </div>
              )
            })}
          </div>
      </div>
    </section>

    <section style={{backgroundImage:`url(${cta})`, backgroundPosition:'center'}}>
      <div className="container">
          <div className="row">
              <div className="col-lg-4 col-md-6">
                  <div className="cta-review bg-primary shadow rounded p-4">
                      <ClientTwo/>
                  </div>
              </div>
          </div>
      </div>
    </section>

    <section className="section">
      <div className="container">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mt-5 pt-4">
                      <h4 className="title mb-4">Our Dream Team</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
          <TeamOne/>
      </div>
      <div className="container mt-100 mt-60">
          <About/>
      </div>

      <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Latest Blog & News</h4>
                      <p className="text-muted para-desc mx-auto mb-0">Build responsive, mobile-first projects on the web with the world's most popular front-end component library.</p>
                  </div>
              </div>
          </div>
          <BlogOne/>
      </div>
    </section>
    <Footer/>
    </>
  )
}
